// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34LdL","colBig":"styles_colBig__3azVv","colSmall":"styles_colSmall__xp4r7"};